export type StateType = {
  term: string;
  termType: string;
  searchType: string;
  searchWordsPerPage: number;
  page: number;
  partsOfSpeech: string; // 'nomen' | 'verb' | 'adjektiv' | 'zahlenwort' | 'floskel';
  basic: {
    Silbenanzahl: number[];
    Silbenstruktur: string[];
    Wortakzent: number[];
    Wortfrequenz: string[];
    Genus: string[];
    Numerus: number[];
  };
  phonemes: {
    initialSelected: string[];
    initialUnselected: string[];
    medialSelected: string[];
    medialUnselected: string[];
    finalSelected: string[];
    finalUnselected: string[];
  };
};

export const PARTS_OF_SPEECH_KEY = {
  nomen: 'nouns',
  verb: 'verbs',
  adjektiv: 'adjectives',
  zahlenwort: 'numberWords',
  floskel: 'fillerWords',
};

interface ResetStateActionType {
  type: 'RESET_STATE';
  payload: StateType | {};
}

interface OuterStateActionType {
  type: 'OUTER_STATE';
  payload: {
    name: keyof StateType;
    value: unknown;
  };
}

interface ChangePageActionType {
  type: 'CHANGE_PAGE';
  payload: {
    arrowName: 'right' | 'left' | null;
    value: number;
  };
}

interface BasicStateActionType {
  type: 'BASIC_STATE';
  payload: {
    name: keyof StateType['basic'];
    isRemove: boolean;
    value: unknown;
  };
}

interface PhonemeRowStateActionType {
  type: 'PHONEME_ROW_STATE';
  payload: {
    name: 'initial' | 'medial' | 'final';
    isRemove: boolean;
    values: string[];
  };
}
interface PhonemeAllStateActionType {
  type: 'PHONEME_ALL_STATE';
  payload: {
    name: 'initial' | 'medial' | 'final';
    isRemove: boolean;
    values: string[];
  };
}

interface PhonemeStateType {
  type: 'PHONEME_STATE';
  payload: {
    name: 'initial' | 'medial' | 'final';
    isRemove: boolean;
    value: string;
  };
}

export type ActionType =
  | ResetStateActionType
  | OuterStateActionType
  | ChangePageActionType
  | PhonemeRowStateActionType
  | PhonemeAllStateActionType
  | PhonemeStateType
  | BasicStateActionType;
